import i18n from 'l10n';
import ComponentCollection from 'js/models/components.collection';
import InstantWinPageConfigModel from 'js/models/instantwin.page.config.model';

export default {
    voucher: {
        blankVoucher: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business1",
                fontColor: "bgbusiness1",
                backgroundImagePosition: 1
            },
            data: {
                cycle: false,
                redemptionMessages: [{count: 1, message: null}],
                redemptionMessageCount: 1
            }
        },
        points: {
            config: {
                pageTitleText: i18n.t("loyaltycard.card"),
                pageText: i18n.t("loyaltycard.collectpoints"),
                footerText: i18n.t("voucher.yourCompanyName"),
                additionalInfo: i18n.t("loyaltycard.additionalinfo"),
                backgroundColor: "party15",
                fontColor: "bgparty15",
                backgroundImagePosition: 1
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 200, message: i18n.t("loyaltycard.scanmessage")}],
                redemptionMessageCount: 1
            }
        },
        coupon: {
            config: {
                pageTitleText: i18n.t("voucher.twentyPercentOff"),
                pageText: i18n.t("voucher.onSelectedProducts"),
                footerText: i18n.t("voucher.yourCompanyName"),
                backgroundColor: "other18",
                fontColor: "bgother18",
                backgroundImagePosition: 1
            },
            data: {
                cycle: false,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.twentyPercentOffCoupon")}],
                redemptionMessageCount: 1
            }
        },
        giftCard: {
            config: {
                pageTitleText: "20€",
                pageText: i18n.t("voucher.giftCard"),
                footerText: i18n.t("voucher.yourCompanyName"),
                backgroundColor: "party10",
                fontColor: "bgparty10",
                backgroundImagePosition: 1
            },
            data: {
                cycle: false,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.twentyEuroGiftCard")}],
                redemptionMessageCount: 1
            }
        },
        membershipCard: {
            config: {
                pageTitleText: "{subscriber.name} {subscriber.surname}",
                pageText: i18n.t("voucher.premiumMember"),
                footerText: i18n.t("voucher.yourCompanyName"),
                backgroundColor: "other21",
                fontColor: "bgother21",
                backgroundImagePosition: 1
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.goldMember")}],
                redemptionMessageCount: 1
            }
        },
        storeCard: {
            config: {
                pageTitleText: i18n.t("voucher.gold"),
                pageText: i18n.t("voucher.vipMembershipCard"),
                footerText: i18n.t("voucher.yourCompanyName"),
                backgroundColor: "pallete8",
                fontColor: "bgpallete8",
                backgroundImagePosition: 0
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.goldCardMember")}],
                redemptionMessageCount: 1
            }
        },
        appointmentCard: {
            config: {
                pageTitleText: "{subscriber.name} {subscriber.surname}",
                pageText: i18n.t("voucher.appointmentCard.appointmentPlace"),
                footerText: i18n.t("voucher.yourCompanyName"),
                backgroundColor: "pallete3",
                fontColor: "bgpallete3",
                backgroundImagePosition: 1
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.admitToEvent")}],
                redemptionMessageCount: 1
            }
        },
        eventAdmission: {
            config: {
                pageTitleText: i18n.t("voucher.eventName"),
                pageText: i18n.t("voucher.eventDate"),
                footerText: i18n.t("voucher.yourCompanyName"),
                subFooterText: i18n.t("voucher.eventRoadStr"),
                backgroundColor: "business13",
                fontColor: "bgbusiness13",
                backgroundImagePosition: 1
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.admitToEvent")}],
                redemptionMessageCount: 1
            }
        },
        identificationCard: {
            config: {
                pageTitleText: "{subscriber.name} {subscriber.surname}",
                pageText: i18n.t("voucher.companyEmployee"),
                footerText: i18n.t("voucher.yourCompanyName"),
                subFooterText: i18n.t("voucher.venueaddress"),
                backgroundColor: "pallete7",
                fontColor: "bgpallete7",
                backgroundImagePosition: 0
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.cardBelongsTo")}],
                redemptionMessageCount: 1
            }
        },
        showTicket: {
            config: {
                pageTitleText: i18n.t("voucher.theXyzEvent"),
                pageText: i18n.t("voucher.eventDate"),
                footerText: i18n.t("voucher.yourCompanyName"),
                subFooterText: i18n.t("voucher.eventRoadStr"),
                backgroundColor: "sports5",
                fontColor: "bgsports5",
                backgroundImagePosition: 1
            },
            data: {
                cycle: false,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.oneAdmissionToXyzBand")}],
                redemptionMessageCount: 1
            }
        },
        seasonTicket: {
            config: {
                pageTitleText: i18n.t("voucher.seasonTicket2018"),
                pageText: "{subscriber.name} {subscriber.surname}",
                footerText: i18n.t("voucher.xyzFootballTeam"),
                subFooterText: "",
                backgroundColor: "sports5",
                fontColor: "bgsports5",
                backgroundImagePosition: 1
            },
            data: {
                cycle: true,
                redemptionMessages: [{count: 1, message: i18n.t("voucher.messageScannerXYZFootball")}],
                redemptionMessageCount: 1
            }
        }
    },
    survey: {
        blankSurvey: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business1",
                fontColor: "bgbusiness1",
                components: new ComponentCollection([
                    {titleText: "", mainText: "", footerText: "", type: "SurveyFormattedText"}
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
        },
        invitation: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "party7",
                fontColor: "bgparty7",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("party.partytitle"), mainText: i18n.t("party.partydate"),
                        footerText: i18n.t("party.partyplace"), type: "SurveyFormattedText"
                    },
                    {
                        title: i18n.t("party.partyquestion1"), required: true, type: "SurveyMultipleChoice",
                        'multiple': false, choices: [i18n.t("party.partyanswer1a"),
                            i18n.t("party.partyanswer1b")]
                    },
                    {
                        title: i18n.t("party.partyquestion2"), textQuestion: "", required: true,
                        type: "SurveyFreeText"
                    },
                    {
                        title: i18n.t("party.partyquestion3"), textQuestion: "", required: true,
                        type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "Invit"
        },
        customerFeedback: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business2",
                fontColor: "bgbusiness2",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("survey.title"), mainText: i18n.t("survey.text"),
                        footerText: i18n.t("survey.footer"), type: "SurveyFormattedText"
                    },
                    {title: i18n.t("survey.rating"), required: true, type: "SurveyStarRating"},
                    {
                        title: i18n.t("survey.suggestions"),
                        textQuestion: i18n.t("survey.suggestionsfooter"),
                        required: true,
                        type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "CustFeed"
        },
        eventFeedback: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "party3",
                fontColor: "bgparty3",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("eventfeedback.eventfeedbacktitle"),
                        mainText: i18n.t("eventfeedback.eventthankcustomers"),
                        footerText: i18n.t("eventfeedback.eventfeedbackmessage1"),
                        type: "SurveyFormattedText"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion1"), required: true,
                        type: "SurveyStarRating"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion2"), textQuestion: "",
                        required: true, type: "SurveyFreeText"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion3"), required: true,
                        type: "SurveyStarRating"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion4"), textQuestion: "",
                        required: true, type: "SurveyFreeText"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion5"), required: true,
                        type: "SurveyStarRating"
                    },
                    {
                        title: i18n.t("eventfeedback.demofeedbackquestion6"), textQuestion: "",
                        required: true, type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "EventFeed"
        },
        emergencyAnnouncement: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other1",
                fontColor: "bgother1",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("emergencyannouncement.emegrtitle"),
                        mainText: i18n.t("emergencyannouncement.orgaddress"),
                        footerText: i18n.t("emergencyannouncement.orgcity"),
                        type: "SurveyFormattedText"
                    },
                    {
                        titleText: "",
                        mainText: i18n.t("emergencyannouncement.demoannouncement"),
                        footerText: i18n.t("emergencyannouncement.announcementmessage"),
                        type: "SurveyFormattedText"
                    },
                    {
                        title: i18n.t("emergencyannouncement.altdemoannouncement"),
                        textQuestion: "",
                        type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: "",
                endFooter: ""
            },
            description: "EmergAn"
        },
        customerSatisfaction: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business9",
                fontColor: "bgbusiness9",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("survey.title"), mainText: i18n.t("survey.text"),
                        footerText: i18n.t("survey.footer"), type: "SurveyFormattedText"
                    },
                    {
                        title: i18n.t("surveyCustSat.recommendation"),
                        required: true,
                        type: "SurveyStarRating",
                        description: 'CustSat',
                        size: 10
                    },
                    {
                        title: i18n.t("surveyCustSat.satisfactionWithOurCompany"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer1a"),
                            i18n.t("surveyCustSat.demoanswer1b"),
                            i18n.t("surveyCustSat.demoanswer1c"),
                            i18n.t("surveyCustSat.demoanswer1d"),
                            i18n.t("surveyCustSat.demoanswer1e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.productDescription"),
                        required: true, 'multiple': true, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer2a"),
                            i18n.t("surveyCustSat.demoanswer2b"),
                            i18n.t("surveyCustSat.demoanswer2c"),
                            i18n.t("surveyCustSat.demoanswer2d"),
                            i18n.t("surveyCustSat.demoanswer2e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.qualityOfProductService"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer3a"),
                            i18n.t("surveyCustSat.demoanswer2b"),
                            i18n.t("surveyCustSat.demoanswer3c"),
                            i18n.t("surveyCustSat.demoanswer2h"),
                            i18n.t("surveyCustSat.demoanswer3e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.meetCustomerNeeds"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer4a"),
                            i18n.t("surveyCustSat.demoanswer4b"),
                            i18n.t("surveyCustSat.demoanswer4c"),
                            i18n.t("surveyCustSat.demoanswer4d"),
                            i18n.t("surveyCustSat.demoanswer4e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.productEvaluation"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer4b"),//very well
                            i18n.t("surveyCustSat.demoanswer5b"),
                            i18n.t("surveyCustSat.demoanswer5c"),
                            i18n.t("surveyCustSat.demoanswer5d"),
                            i18n.t("surveyCustSat.demoanswer5e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.companyResponse"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer6a"),
                            i18n.t("surveyCustSat.demoanswer6b"),
                            i18n.t("surveyCustSat.demoanswer6c"),
                            i18n.t("surveyCustSat.demoanswer6d"),
                            i18n.t("surveyCustSat.demoanswer6e"),
                            i18n.t("surveyCustSat.demoanswer6f")]
                    },
                    {
                        title: i18n.t("surveyCustSat.customerRegisteredTime"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer7a"),
                            i18n.t("surveyCustSat.demoanswer7b"),
                            i18n.t("surveyCustSat.demoanswer7c"),
                            i18n.t("surveyCustSat.demoanswer7d"),
                            i18n.t("surveyCustSat.demoanswer7e"),
                            i18n.t("surveyCustSat.demoanswer7f")]
                    },
                    {
                        title: i18n.t("surveyCustSat.buyNewProducts"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer8a"),
                            i18n.t("surveyCustSat.demoanswer8b"),
                            i18n.t("surveyCustSat.demoanswer8c"),
                            i18n.t("surveyCustSat.demoanswer8d"),
                            i18n.t("surveyCustSat.demoanswer8e")]
                    },
                    {
                        title: i18n.t("surveyCustSat.questions"),
                        textQuestion: "", required: true, type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "CustSat"
        },
        brandLoyalty: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business14",
                fontColor: "bgbusiness14",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("survey.title"), mainText: i18n.t("survey.text"),
                        footerText: i18n.t("survey.footer"), type: "SurveyFormattedText"
                    },
                    {
                        title: i18n.t("surveyCustSat.recommendation"),
                        required: true,
                        type: "SurveyStarRating",
                        description: 'CustSat',
                        size: 10
                    },
                    {
                        title: i18n.t("brandLoyalty.productConsideration"),
                        required: true, 'multiple': false, type: "SurveyMultipleChoice",
                        choices: [i18n.t("surveyCustSat.demoanswer8a"),
                            i18n.t("surveyCustSat.demoanswer8b"),
                            i18n.t("surveyCustSat.demoanswer8c"),
                            i18n.t("surveyCustSat.demoanswer8d"),
                            i18n.t("surveyCustSat.demoanswer8e")]
                    },
                    {
                        title: i18n.t("brandLoyalty.storeVisits"),
                        textQuestion: "", required: true, type: "SurveyFreeText"
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "BrandLoyalty"
        }
    },
    optIn: {
        "create-new-emailOptin": {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other18",
                fontColor: "bgother18",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("optin.pretitle"),
                        mainText: i18n.t("optin.premaintext"),
                        footerText: i18n.t("optin.preenter"),
                        type: "SurveyFormattedText"
                    }
                ]),
                expiredTitleText: i18n.t("instantWin.expiredTitleText"),
                expiredPageText: i18n.t("instantWin.expiredPageText"),
                expiredFooterText: i18n.t("instantWin.expiredFooterText"),
                endTitle: i18n.t("optin.posttitle"),
                endText: i18n.t("optin.postmaintext"),
                endFooter: i18n.t("optin.postenter")
            },
            description: "OptIn"
        },
        eventRegistration: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business2",
                fontColor: "bgbusiness2",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("eventregistration.eventtitle"),
                        mainText: i18n.t("eventregistration.eventtime"),
                        footerText: i18n.t("eventregistration.eventaddress"),
                        type: "SurveyFormattedText"
                    },
                    {
                        textQuestion: "Firstname",
                        required: true,
                        kind: "firstname",
                        type: "SurveyFreeText",
                        numberOfCharacters: 20
                    },
                    {
                        textQuestion: "Lastname",
                        required: true,
                        kind: "lastname",
                        type: "SurveyFreeText",
                        numberOfCharacters: 35
                    }
                ]),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("survey.endtext"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "EventReg"
        },
        loyaltyRegistration: {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "business14",
                fontColor: "bgbusiness14",
                backgroundImagePosition: 1,
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("loyaltyRegistration.joinourprogram"),
                        mainText: i18n.t("loyaltyRegistration.enterinfobelow"),
                        footerText: i18n.t("loyaltyRegistration.receivecardafter"),
                        type: "SurveyFormattedText"
                    },
                    {
                        textQuestion: "Email",
                        kind: "email",
                        required: true,
                        type: "SurveyFreeText"
                    }
                ]),
                expiredTitleText: i18n.t("loyaltyRegistration.youarelate"),
                expiredPageText: i18n.t("loyaltyRegistration.serviceexpired"),
                expiredFooterText: i18n.t("loyaltyRegistration.contactus"),
                endTitle: i18n.t("loyaltyRegistration.thankyouforjoining"),
                endText: i18n.t("loyaltyRegistration.useyourcard"),
                endFooter: i18n.t("loyaltyRegistration.soonreceivecard")
            },
            description: "LoyaltyReg"
        },
    },
    payPalPayment: {
        "create-new-payPalPaymentOptin": {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other18",
                fontColor: "bgother18",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("payPal.pretitle"),
                        mainText: i18n.t("optin.premaintext"),
                        footerText: i18n.t("optin.preenter"),
                        type: "SurveyFormattedText"
                    },
                    {price: 0.0, itemName: i18n.t("payPalItemName"), type: "PayPalButton"},
                    {
                        textQuestion: i18n.t("subscriber.firstname"),
                        kind: "firstname",
                        required: true,
                        type: "SurveyFreeText"
                    },
                    {
                        textQuestion: i18n.t("subscriber.lastname"),
                        kind: "lastname",
                        required: true,
                        type: "SurveyFreeText"
                    },
                    {
                        textQuestion: i18n.t("subscriber.mobile"),
                        kind: "mobile",
                        required: true,
                        type: "SurveyFreeText"
                    }
                ]),
                expiredTitleText: i18n.t("instantWin.expiredTitleText"),
                expiredPageText: i18n.t("instantWin.expiredPageText"),
                expiredFooterText: i18n.t("instantWin.expiredFooterText"),
                endTitle: i18n.t("survey.endtitle"),
                endText: i18n.t("payPalPayment.procurementConcluded"),
                endFooter: i18n.t("survey.endfooter")
            },
            description: "PayPalPayment",
            instantWinPageConfig: {
                rulesFootnote: i18n.t("paypalPayment.defaultRules"),
            }
        }
    },
    quizOptin: {
        "create-new-quiz": {
            config: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other18",
                fontColor: "bgother18",
                components: new ComponentCollection([
                    {
                        titleText: "",
                        mainText: "",
                        footerText: "",
                        type: "SurveyFormattedText"
                    }
                ])
            },
            description: "quizOptin",
            instantWinPageConfig: {
                expiredTitleText: i18n.t("instantWin.expiredTitleText"),
                expiredPageText: i18n.t("instantWin.expiredPageText"),
                expiredFooterText: i18n.t("instantWin.expiredFooterText"),

                endTitleTextWinner: i18n.t("instantWin.endTitleTextWinner"),
                endPageTextWinner: i18n.t("instantWin.endPageTextWinner"),
                endFooterTextWinner: i18n.t("instantWin.endFooterTextWinner"),

                endTitleTextLoser: i18n.t("instantWin.endTitleTextLoser"),
                endPageTextLoser: i18n.t("instantWin.endPageTextLoser"),
                endFooterTextLoser: i18n.t("instantWin.endFooterTextLoser"),

                winRulesList: new InstantWinPageConfigModel.prototype.model.winRulesList([
                    {
                        count: 10,
                        message: null
                    }
                ]),
                rulesFootnote: i18n.t("instantWin.defaultRules"),
                type: "USER_METRICS"
            }
        }
    },
    instantWin: {
        instantWin: {
            instantWinPageConfig: {
                expiredTitleText: i18n.t("instantWin.expiredTitleText"),
                expiredPageText: i18n.t("instantWin.expiredPageText"),
                expiredFooterText: i18n.t("instantWin.expiredFooterText"),

                endTitleTextWinner: i18n.t("instantWin.endTitleTextWinner"),
                endPageTextWinner: i18n.t("instantWin.endPageTextWinner"),
                endFooterTextWinner: i18n.t("instantWin.endFooterTextWinner"),

                endTitleTextLoser: i18n.t("instantWin.endTitleTextLoser"),
                endPageTextLoser: i18n.t("instantWin.endPageTextLoser"),
                endFooterTextLoser: i18n.t("instantWin.endFooterTextLoser"),

                winRulesList: new InstantWinPageConfigModel.prototype.model.winRulesList([
                    {
                        count: 100,
                        message: null
                    }
                ]),
                rulesFootnote: i18n.t("instantWin.defaultRules"),
                type: "USER_PERCENTAGE"
            },
            surveyPageConfig: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other7",
                fontColor: "bgother7",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("instantWin.thisIsInstantWinTitle"),
                        mainText: i18n.t("optin.premaintext"),
                        footerText: i18n.t("optin.preenter"),
                        type: "SurveyFormattedText"
                    }
                ])
            },
            description: "instantWin"
        },
        sweepStakes: {
            instantWinPageConfig: {
                expiredTitleText: i18n.t("instantWin.expiredTitleText"),
                expiredPageText: i18n.t("instantWin.expiredPageText"),
                expiredFooterText: i18n.t("instantWin.expiredFooterText"),

                endTitleTextWinner: i18n.t("survey.endtitle"),
                endPageTextWinner: i18n.t("instantWin.hopeWillWin"),
                endFooterTextWinner: i18n.t("instantWin.winnersWillBeAnnounced"),

                endTitleTextLoser: i18n.t("instantWin.endTitleTextLoser"),
                endPageTextLoser: i18n.t("instantWin.endPageTextLoser"),
                endFooterTextLoser: i18n.t("instantWin.endFooterTextLoser"),

                winRulesList: new InstantWinPageConfigModel.prototype.model.winRulesList([
                    {
                        count: 10,
                        message: null
                    }
                ]),
                rulesFootnote: i18n.t("instantWin.defaultRulesSweepstakes"),
                type: "USER_METRICS"
            },
            surveyPageConfig: {
                pageTitleText: "",
                pageText: "",
                footerText: "",
                backgroundColor: "other6",
                fontColor: "bgother6",
                components: new ComponentCollection([
                    {
                        titleText: i18n.t("instantWin.thisIsSweepstakesTitle"),
                        mainText: i18n.t("optin.premaintext"),
                        footerText: i18n.t("optin.preenter"),
                        type: "SurveyFormattedText"
                    }
                ])
            },
            description: "sweepstakes"
        }
    }
};